// extracted by mini-css-extract-plugin
module.exports = {"root":"quickbooks_root__2wcPY","infoBtn":"quickbooks_infoBtn__3Pf_y","formBox":"quickbooks_formBox__3sLzK","formFooter":"quickbooks_formFooter__1yuvP"};